module.exports = __webpack_public_path__ + "static/media/logo_ecg_css.ee7ce580.svg";